import React, { useCallback, useState, useEffect } from 'react';
import Spinner from 'ui/Spinner';
import { useFetch } from 'hooks';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import { IconPreview, IconPreviewOff } from '@seismic/mantle';

const ApiKeys = () => {
  const [apiKey, setApiKey] = useState('');
  const [subdomain, setSubdomain] = useState('');
  const [isMasked, setIsMasked] = useState(true);
  const { data, loading } = useFetch('/settings/api_webhook_tab');

  const generateApiKey = useCallback(async () => {
    const { apiKey: generatedApiKey } = await request.putJSON(
      routes.SETTINGS.GENERATE_API_KEY,
    );
    setApiKey(generatedApiKey);
  }, [setApiKey]);

  useEffect(() => {
    if (data) {
      const { apiKey: fetchedApiKey, subdomain: fetchedSubdomain } = data;
      setApiKey(fetchedApiKey);
      setSubdomain(fetchedSubdomain);
    }
  }, [data]);

  const toggleMask = e => {
    e.stopPropagation();
    setIsMasked(!isMasked);
  };

  return (
    <div className="panel_body row">
      <div className="Module col-md-12">
        <h3 className="SettingsContent-heading">
          {t('settings.tab.api_webhook.api_docs')}
        </h3>
        <hr />

        <div className="row">
          <div className="col-md-8">
            <div id="api_keys" className="controls">
              {loading && <Spinner />}
              {!loading && apiKey && (
                <table id="api-table" className="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Subdomain</th>
                      <td>{subdomain}</td>
                    </tr>
                    <tr>
                      <th>API Key</th>
                      <td className="w-100p">
                        <div className="d-f jc-sb ai-c">
                          <span>{isMasked ? '••••••••••••••' : apiKey}</span>
                          <span
                            onClick={toggleMask}
                            onKeyDown={e => e.key === 'Enter' && toggleMask()}
                            role="button"
                            tabIndex={0}
                            className="c-p ml-8"
                          >
                            {isMasked ? <IconPreview /> : <IconPreviewOff />}
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
              {!loading && !apiKey && (
                <button
                  type="button"
                  onClick={generateApiKey}
                  className="NewButton NewButton--blue"
                >
                  {t('settings.tab.api_webhook.api_permission')}
                </button>
              )}
              <br />
              <a
                href="https://docs.lessonly.com"
                className="decorated"
                target="_blank"
                rel="noreferrer"
              >
                {t('settings.tab.api_webhook.api_docs')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiKeys;
